import * as React from "react";
import { renderFavoritesIcon } from "./renderFavoritesIcon";
import { CountLinkParams } from "../../../../../typings/CountLinkParams";
import { CardDetailsParams } from "../../../../../typings/CardDetailsParams";
import { renderMarketsCount } from "./renderMarketsCount";

export const renderMarketsCountLink = (props: CountLinkParams, componentPrefix: string, market?: CardDetailsParams) => {
    return (
        <a href={props.linkUrl} onClick={props.handlers.eventCard} className={`rj-ev-list__${componentPrefix}__section rj-ev-list__${componentPrefix}__section--counter`} data-uat={`a-ev-list-${componentPrefix}-section-counter`}>
            {props.showFavorites && renderFavoritesIcon(props.isInFavorites, props.handlers.favorites)}
            {renderMarketsCount(componentPrefix, props.count)}
        </a>
    )
}